import React, { FC } from 'react';

import { authService } from 'services';
import { useAuth, useMutation } from 'hooks';
import { Logout } from 'components/icons';
import { Button } from 'components/ui';
import { ButtonProps } from 'types/components';

type LogoutButtonProps = Omit<ButtonProps, 'loading' | 'onClick'>;

const LogoutButton: FC<LogoutButtonProps> = (props) => {
  const auth = useAuth();

  const logoutMutation = useMutation({
    mutationFn: authService.logout,
  });

  return auth.authenticated && (
    <Button
      type="default"
      icon={<Logout />}
      loading={logoutMutation.isPending}
      onClick={() => logoutMutation.mutateAsync()}
      {...props}
    />
  );
};

export default LogoutButton;
